<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>码生命周期查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="handle-box">
        <el-form ref="form" :model="form" label-width="100px" @keyup.enter.native="formlistget">
          <el-row>
            <el-col :span="6">
              <el-form-item label="查询溯码:" prop="qrcode">
                <el-input
                  v-model="form.qrcode"
                  style="width:100%"
                  clearable
                  placeholder="请输入查询码"
                />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="操作模块" prop="module">
                <el-select
                  v-model="form.module"
                  multiple
                  style="width:100%"
                  placeholder="请选择模块"
                  @remove-tag="preventRemoveRemoved"
                >
                  <el-option label="生码" value="1"></el-option>
                  <!-- <el-option label="赋码采集" value="2"></el-option> -->
                  <el-option label="包装关联" value="4" disabled></el-option>
                  <el-option label="出库" value="5"></el-option>
                  <el-option label="经销商" value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8" :offset="1">
              <el-button @click="resetForm">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="formlistget"
                v-permission="['informationinquiry_select']"
              >搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
        <br />
      </div>

      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>码生命周期查询</h4>
          <el-divider></el-divider>

          <el-table
            border
            v-loading="tableLoading"
            element-loading-text="拼命加载中"
            :data="detailList"
            style="width:100%;"
          >
            <el-table-column
              prop="code"
              label="码"
              min-width="80"
            />
            <!-- 状态列：显示中文 -->
            <el-table-column
              label="状态"
              min-width="50">
              <template slot-scope="scope">
                {{ getStatusText(scope.row.status) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="time"
              label="时间"
              min-width="50"
            />
            <el-table-column
              prop="info"
              label="辅助情报"
              min-width="400"
              show-overflow-tooltip
            />
            <template slot="empty">
              <span>暂无数据</span>
            </template>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { qrcodelifecycleQuery } from "@/api/plant";

export default {
  name: "home",
  data() {
    return {
      form: {
        qrcode: "",
        module: ["4"],
      },
      detailList: [],
      tableLoading: false,
    };
  },
  methods: {
    // 状态映射（完全按你给的枚举）
    getStatusText(status) {
      const statusMap = {
        1: "生码",
        2: "赋码",
        3: "采集",
        4: "包装关联",
        41: "包装关联 解除",
        42: "包装关联 替换",
        5: "出库",
        6: "经销商发货",
        61: "经销商签收",
        62: "经销商退货",
        7: "终端签收",
        71: "终端退货"
      };
      return statusMap[status] || status;
    },

    preventRemoveRemoved(tag) {
      if (tag === "4") {
        this.$message.warning("包装关联模块为必选项，不可取消");
        if (!this.form.module.includes(tag)) {
          this.form.module.push(tag);
        }
      }
    },

    formlistget() {
      if (!this.form.qrcode) {
        this.$message.warning("请输入码");
        return;
      }
      if (!this.form.module || this.form.module.length === 0) {
        this.$message.warning("请选择操作模块");
        return;
      }

      this.tableLoading = true;
      let params = new URLSearchParams();
      params.append("qrcode", this.form.qrcode);
      this.form.module.forEach(m => {
        params.append("module", m);
      });

      qrcodelifecycleQuery(params).then((response) => {
        this.detailList = response.data || [];
      }).finally(() => {
        this.tableLoading = false;
      });
    },

    resetForm() {
      this.$refs.form.resetFields();
      this.form.qrcode = "";
      this.form.module = ["4"];
      this.detailList = [];
    },
  },
};
</script>

<style scoped></style>